import { makeUseAnalytics } from '@plato/app-core/hooks/make-use-analytics';
import type { ViewMode } from '@plato/app-core/hooks/use-view-mode';

type CustomerListAnalyticsEvents = {
    customer_list_filter_used: {
        filters: string[];
    };
    customer_list_sort_used: {
        column: string;
        direction: 'ASC' | 'DESC';
    };
    customer_list_visit_column_tooltip_opened: {
        column: 'visits_per_100k' | 'last_visit';
        view_mode: ViewMode;
    };
};

export const useAnalytics = makeUseAnalytics<CustomerListAnalyticsEvents>();
